import React,{ useEffect,useRef } from 'react'
import { useParams } from 'react-router-dom';
import { host } from '../axiosInterceptor';

function DigitalPublicationView({ path = ""}) {

    const { id } = useParams();
    const pdfViewerRef = useRef(null);

    useEffect(() => {
      const pdfViewer = pdfViewerRef.current;
  
      const simulateKeyPress = () => {
        const isWindows = navigator.platform.toUpperCase().indexOf('WIN32') >= 0;
  
        const event = new KeyboardEvent('keydown', {
          bubbles: true,
          cancelable: true,
          key: 'F',
          code: 'KeyF',
          keyCode: 70,
          charCode: 70,
          ctrlKey: isWindows,
          metaKey: !isWindows,  // Inverso para plataformas que no sean Windows
        });
  
        document.dispatchEvent(event);
      };
  
      // Espera un poco para asegurarte de que el PDF esté cargado
      const timeoutId = setTimeout(() => {
        if (pdfViewer) {
          pdfViewer.focus();  // Asegúrate de que el foco esté en el visor de PDF
          simulateKeyPress();  // Simula el atajo de teclado
        }
      }, 1000);
  
      return () => clearTimeout(timeoutId); // Limpieza al desmontar
    }, []);

  return (
    <embed 
      id='pdfViewer' 
      ref={pdfViewerRef}
        src={`${host}/${path}/${id}.pdf`} 
        type="application/pdf" 
        style={{ height: '99vh', width: '100%' }} 
        // onLoad={loader_pdf}
      />
  )
}


export default DigitalPublicationView